/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type SiteNav_viewer = {
    readonly navigation: {
        readonly modules: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SiteNavItem_navigationModule">;
        } | null> | null;
    } | null;
    readonly " $refType": "SiteNav_viewer";
};
export type SiteNav_viewer$data = SiteNav_viewer;
export type SiteNav_viewer$key = {
    readonly " $data"?: SiteNav_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SiteNav_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "previewKey"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SiteNav_viewer",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "rootId",
                    "variableName": "previewKey"
                }
            ],
            "concreteType": "Navigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "NavigationModule",
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceId",
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SiteNavItem_navigationModule"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '0ca62205dba26f7abb8476a182375c19';
export default node;
